import { PortfolioItemModel } from "../types/PortfolioItemModel";
import { PortfolioItemUpdateModel } from "../types/PortfolioItemUpdateModel";
import { AssetType } from "../../../shared/types/AssetType";

class PortfolioItemMappers {
    mapForEditing(item: PortfolioItemModel): PortfolioItemUpdateModel {
        return {
            externalId: item.externalId,
            internalId: item.internalId,
            exchangeOrderId: item.exchangeOrderId,
            autoOrderConfiguration: item.autoOrderConfiguration,
            state: item.state,
            isActive: item.isActive,
            locked: item.locked,
            type: item.type,
            strike: item.strike,
            expireAt: item.expireAt,
            symbol: item.symbol,
            size: item.size,
            openPrice: item.openPrice,
            markPrice: item.markPrice,
            openedPositionAt: item.openedPositionAt,
            underlyingPriceAtOpen: item.underlyingPriceAtOpen,
            impliedVolatilityAtOpen: item.impliedVolatilityAtOpen,
            delta: item.delta,
            gamma: item.gamma,
            vega: item.vega,
            theta: item.theta,
            comment: item.comment,
            dateForPricing: item.dateForPricing,
            impliedVolatilityForPricing: item.impliedVolatilityForPricing,
            underlyingPriceForPricing: item.underlyingPriceForPricing,
        }
    }

    map(source: PortfolioItemUpdateModel, destination: PortfolioItemModel): void {
        destination.state = source.state;
        destination.autoOrderConfiguration = source.autoOrderConfiguration;
        destination.isActive = source.isActive;
        destination.locked = source.locked;
        destination.size = source.size;
        destination.openPrice = source.openPrice;
        destination.markPrice = source.markPrice;
        destination.type = source.type;
        destination.strike = source.strike;
        destination.expireAt = source.expireAt;
        destination.symbol = source.symbol;
        destination.comment = source.comment;

        destination.openedPositionAt = source.openedPositionAt;
        destination.underlyingPriceAtOpen = source.underlyingPriceAtOpen;
        destination.impliedVolatilityAtOpen = source.impliedVolatilityAtOpen ?? null;

        destination.dateForPricing = source.dateForPricing;
        destination.impliedVolatilityForPricing = source.impliedVolatilityForPricing;
        destination.underlyingPriceForPricing = source.underlyingPriceForPricing;
    }

    getTypeStringValue(type: AssetType): string {
        switch(type) {
            case AssetType.Call:
                return "Call";
            case AssetType.Put:
                return "Put";
            case AssetType.Futures:
                return "Futures";
            case AssetType.Spot:
                return "Spot";
        }
    }

    getType(type: string): AssetType {
        switch(type) {
            case "Call":
                return AssetType.Call;
            case "Put":
                return AssetType.Put;
            case "Futures":
                return AssetType.Futures;
            case "Spot":
                return AssetType.Spot;
            default:
                throw new Error("Some of AssetType value is not supported.");
        }
    }    
    
    getSymbolName(symbol: string, type: AssetType): string {
        if (type === AssetType.Call || type === AssetType.Put)
            return symbol;

        switch (type) {
            case AssetType.Spot:
                return `${symbol} *S`;
            case AssetType.Futures:
                return `${symbol} *F`;
            default:
                throw new Error("Some of AssetType value is not supported.");
        }
    }
}

export const portfolioItemMappers = new PortfolioItemMappers();
